import React from 'react';

import FormBase from '../FormBase';
import TextField from '../../../../components/Textfields/TextField';
import SelectSystemCode from '../../../../components/Dropdown/SelectSystemCode';

import { useAccountContext } from '../Data/accountContext';
import { hasError, validateEmployment } from '../Data/validation';
import { saveRegistrationEmployment } from '../../../../services/RegistrationService';

export default function FormEmployemnt() {
  const { account, setAccount } = useAccountContext();
  const [validation, setValidation] = React.useState({});

  const handleChange = (e) => {
    const copy = { ...account };

    const input = e.currentTarget.name ? e.currentTarget : e.target;

    copy.primaryOwner.employment[input.name] = input.value;
    setAccount({ ...copy });
  };

  const handleSave = async () => {
    let errs = validateEmployment(account.primaryOwner.employment);
    setValidation(errs);

    if (hasError(errs)) {
      console.log('employment errs', errs);
      return { acct: account, err: true };
    }

    await saveRegistrationEmployment(account.primaryOwner.employment);

    return { acct: account, err: false };
  };

  const data = account.primaryOwner.employment || {};

  return (
    <FormBase
      name="employment"
      header="Employment"
      subHeader=""
      faq="Employment"
      save={handleSave}
    >
      <form className="employment-form-w" autoComplete="off">
        <input type="hidden" autoComplete="off" />
        <SelectSystemCode
          required={true}
          error={!!validation.employmentStatus}
          msg={validation.employmentStatus}
          name="employmentStatus"
          label="Employment Status"
          placeholder="Employment Status"
          type="Employment Status"
          subType="Client Site"
          value={data.employmentStatus || ''}
          onChange={handleChange}
        />
        {['Employed', 'Self-Employed'].includes(data.employmentStatus) && (
          <div>
            {data.employmentStatus === 'Employed' && (
              <TextField
                required={true}
                error={!!validation.employmentName}
                msg={validation.employmentName}
                mt={20}
                max={50}
                name="employmentName"
                label="Employer Name"
                placeholder="Employer Name"
                type="text"
                value={data.employmentName || ''}
                onChange={handleChange}
              />
            )}
            {data.employmentStatus === 'Employed' && (
              <TextField
                mt={20}
                name="yearsEmployed"
                label="Years Employed"
                placeholder="Years Employed"
                type="number"
                value={data.yearsEmployed || ''}
                onChange={handleChange}
              />
            )}
            {data.employmentStatus === 'Self-Employed' && (
              <TextField
                required={true}
                error={!!validation.natureOfBusiness}
                msg={validation.natureOfBusiness}
                mt={20}
                max={50}
                name="natureOfBusiness"
                label="Doing Business As"
                placeholder="Doing Business As"
                type="text"
                value={data.natureOfBusiness || ''}
                onChange={handleChange}
              />
            )}
            <TextField
              required={true}
              error={!!validation.employmentOccupation}
              msg={validation.employmentOccupation}
              mt={20}
              max={50}
              name="employmentOccupation"
              label="Occupation"
              placeholder="Occupation"
              type="text"
              value={data.employmentOccupation || ''}
              onChange={handleChange}
            />
          </div>
        )}
        {data.employmentStatus === 'Unemployed' && (
          <div>
            <TextField
              required={true}
              error={!!validation.previousEmploymentName}
              msg={validation.previousEmploymentName}
              mt={20}
              max={50}
              name="previousEmploymentName"
              label="Previous Employer Name"
              placeholder="Previous Employer Name"
              type="text"
              value={data.previousEmploymentName || ''}
              onChange={handleChange}
            />
            <TextField
              mt={20}
              name="yearsEmployed"
              label="Years Employed"
              placeholder="Years Employed"
              type="number"
              value={data.yearsEmployed || ''}
              onChange={handleChange}
            />
            <TextField
              required={true}
              error={!!validation.employmentOccupation}
              msg={validation.employmentOccupation}
              mt={20}
              max={50}
              name="employmentOccupation"
              label="Occupation"
              placeholder="Occupation"
              type="text"
              value={data.employmentOccupation || ''}
              onChange={handleChange}
            />
          </div>
        )}
      </form>
    </FormBase>
  );
}
